import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";
import moment from "moment";

const ViewStudentAssignment = () => {
  const { id, studentid, stdname } = useParams();
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  const [assignmentList, setAssignmentList] = useState([]);
  const [points, setPoints] = useState([]);
  const [evaluatedCopies, setEvaluatedCopies] = useState([]);

  //  ------For TableViewer ------
  const AssignmentListRef = useRef([]);
  AssignmentListRef.current = assignmentList;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  const handlePointsChange = (value, id, i, e) => {
    e.preventDefault();
    console.log(value, id, i);
    const updatedPoints = [...points];
    updatedPoints[i] = parseInt(value);
    setPoints(updatedPoints);

    const updatedAssignmentList = [...assignmentList];
    updatedAssignmentList[i].pointCache = value;
    setAssignmentList(updatedAssignmentList);

    const assignmentListData = updatedAssignmentList.map((assignment) => ({
      point: assignment.point,
      evaluated_copy: assignment.evaluated_copy,
      assignment: assignment.student_assignment,
      check_at: assignment.check_at,
      upload_at: assignment.upload_at,
      idNumber: assignment.asid,
      pointCache: assignment.pointCache,
    }));
    setRowData(assignmentListData);
  };

  const handleEvaluatedCopyChange = (files, id, i, e) => {
    e.preventDefault();
    console.log(files, id, i);

    // Clone the evaluated copies array
    const updatedEvaluatedCopies = [...evaluatedCopies];
    updatedEvaluatedCopies[i] = files[0];
    setEvaluatedCopies(updatedEvaluatedCopies);

    // Clone the assignment list array
    const updatedAssignmentList = [...assignmentList];
    updatedAssignmentList[i].evaluatedCopyCache = files;
    setAssignmentList(updatedAssignmentList);

    const assignmentListData = updatedAssignmentList.map((assignment) => ({
      point: assignment.point,
      evaluated_copy: assignment.evaluated_copy,
      assignment: assignment.student_assignment,
      check_at: assignment.check_at,
      upload_at: assignment.upload_at,
      idNumber: assignment.asid,
      evaluatedCopyCache: assignment.evaluatedCopyCache,
    }));

    setRowData(assignmentListData);
  };

  //----------------------------------------------- submit assignment point   -------------------------------------------------C

  const submitPoints = (id, i) => {
    try {
      if (points[i] === "" || points[i] === undefined) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      fetch(`${config.host_url}assignments/student-assignment-submit/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({
          checking_status: "1",
          point: points[i],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // class created successfully
            triggerNotification("success", "Point submitted successfully.");

            // Update the assignmentList with the new point
            const updatedAssignmentList = [...assignmentList];
            updatedAssignmentList[i].point = points[i];
            setAssignmentList(updatedAssignmentList);

            const assignmentListData = updatedAssignmentList.map(
              (assignment) => ({
                point: assignment.point,
                evaluated_copy: assignment.evaluated_copy,
                assignment: assignment.student_assignment,
                check_at: assignment.check_at,
                upload_at: assignment.upload_at,
                idNumber: assignment.asid,
                pointCache: "",
              })
            );
            setRowData(assignmentListData);
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error submitting points:", error);
      triggerNotification(
        "error",
        "An error occurred while submitting the points."
      );
    }
  };

  //----------------------------------------------- submit evaluated_copy    -------------------------------------------------C

  const submitEvaluatedCopy = (id, i) => {
    try {
      if (evaluatedCopies[i] === "" || evaluatedCopies[i] === undefined) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      const formData = new FormData();
      formData.append("evaluated_copy", evaluatedCopies[i]);
      fetch(`${config.host_url}assignments/evaluated-copy/${id}`, {
        method: "POST",
        headers: {
          token: token,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // class created successfully
            triggerNotification(
              "success",
              "Evaluated copy submitted successfully."
            );
            getAssignmentList();
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error submitting evaluated copy", error);
      triggerNotification(
        "error",
        "An error occurred while submitting the evaluated copy."
      );
    }
  };

  //----------------------------------------------- select /  assignment List table  -------------------------------------------------R
  // Fetch all assignmentList
  const getAssignmentList = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}assignments/student-assignment/${decodeURIComponent(
          atob(id)
        )}/${decodeURIComponent(atob(studentid))} `,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            //  ------For TableViewer ------
            console.log("data: ", data.data);
            const assignmentListData = data.data.map((assignment) => ({
              point: assignment.point,
              evaluated_copy: assignment.evaluated_copy,
              assignment: assignment.student_assignment,
              check_at: assignment.check_at,
              upload_at: assignment.upload_at,
              idNumber: assignment.asid,
              pointCache: "",
              evaluatedCopyCache: "",
            }));
            setRowData(assignmentListData);
            //  ------For TableViewer ------
            setAssignmentList(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching assignmentList.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAssignmentList();
  }, [token]);

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Uploaded At",
      field: "upload_at",
      filter: true,
      valueFormatter: (params) => {
        return `${moment(params.data.upload_at).format("DD/MM/YY")}`;
      },
    },
    {
      headerName: "Assignment",
      field: "assignment",
      width: 280,
      cellRenderer: (params) => (
        <div className="mb-0 pt-1 ">
          <div
            onClick={() =>
              navigate(
                // "/fileanddocviewer/ODI=/aHR0cHMlM0ElMkYlMkZkZWVwdmVjdG8uY29tJTJGYXBpJTJGdXBsb2FkLTglMkYxNjk5MjYxMzE0NTU1LXN0dWRlbnRzLnhsc3g=/assignment/course"
                `/fileanddocviewer/${id}/${studentid}/${btoa(
                  encodeURIComponent(params.data.assignment)
                )}/nm/${stdname}`
              )
            }
          >
            <i className="mdi mdi-file mdi-20px text-success me-3"></i>
            Open Assignment
          </div>
        </div>
      ),
    },
    {
      field: "point",
      width: 280,
      cellRenderer: (params) => (
        <>
          {params.data.point === null ? (
            <div className="input-group mt-2">
              <input
                type="number"
                min={0}
                className="form-control form-control-sm"
                value={params.data.pointCache}
                onChange={(e) =>
                  handlePointsChange(
                    e.target.value,
                    params.data.idNumber,
                    params.rowIndex,
                    e
                  )
                }
              />

              <button
                type="button"
                className="btn btn-primary"
                onClick={
                  () => submitPoints(params.data.idNumber, params.rowIndex)
                  // console.log(params)
                }
              >
                submit
              </button>
            </div>
          ) : (
            <div className="flex">
              <span className="mr-5 self-center">{params.data.point}</span>
              <span className="text-xs text-gray-300 self-center mt-1">
                {params.data.check_at
                  ? moment(params.data.check_at).format(
                      "MMMM Do YYYY, h:mm:ss a"
                    )
                  : moment(Date.now()).format("MMMM Do YYYY, h:mm:ss a")}
              </span>
            </div>
          )}
        </>
      ),
    },
    {
      field: "evaluated_copy",
      headerName: "Evaluated Copy",
      width: 350,
      cellRenderer: (params) => (
        <>
          {params.data.evaluated_copy === null ? (
            <div className="input-group mt-2">
              <input
                type="file"
                className="form-control form-control-sm"
                name={`evaCopy${params.data.idNumber}`}
                id={`evaCopy${params.data.idNumber}`}
                onChange={(e) => {
                  const selectedFiles = e.target.files;
                  handleEvaluatedCopyChange(
                    selectedFiles,
                    params.data.idNumber,
                    params.rowIndex,
                    e
                  );
                }}
              />

              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  submitEvaluatedCopy(params.data.idNumber, params.rowIndex)
                }
              >
                submit
              </button>
            </div>
          ) : (
            <div className="flex h-full ">
              <h6 className="text-slate-950/50 my-auto">
                <a
                  href={params.data?.evaluated_copy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
                >
                  Open Evaluated Copy
                </a>
              </h6>
            </div>
          )}
        </>
      ),
    },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb
        txt="Manage Assignment"
        subpath={["Student List", "View Uploaded Assignments"]}
        url={[`/studentsubmissions/${id}`]}
      />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">
              {" "}
              View Uploaded Assignments - {decodeURIComponent(atob(stdname))}
            </h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                // haveImage
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewStudentAssignment;
